skrilla.controller('financialsCtrl', function ($scope, searchService, queryService, paginationService, currencyService) {
    $scope.pageKey = "financials";

    $scope.tabs = [
        {title: "Daily Reconciliation", active: false},
        {title: "XERO Finances", active: false},
        {title: "Bets For Reporting", active: false},
    ];


    $scope.reset = function () {
        $scope.queryXero = {
            firstDate: new Date()
        }
    };
    $scope.reset();


    $scope.getExchange = function(rate){
        return "$" + (rate / 1000000);
    }

    $scope.searchXero = function() {
        searchService.get("skrillaJobs/zapierFianancesView" + queryService.getQueryString($scope.queryXero, $scope.pageKey)).then(function (response) {
            $scope.xero = response.data;
        });
    }

});


